function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "matrix(2.6666 0 0 2.6666 .0003356 0)",
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "m16 0h-8a5.006 5.006 0 0 0-5 5v18a1 1 0 0 0 1.564 0.825l2.106-1.439 2.106 1.439a1 1 0 0 0 1.13 0l2.1-1.439 2.1 1.439a1 1 0 0 0 1.131 0l2.1-1.438 2.1 1.437a1 1 0 0 0 1.563-0.824v-18a5.006 5.006 0 0 0-5-5zm3 21.1-1.1-0.752a1 1 0 0 0-1.132 0l-2.1 1.439-2.1-1.439a1 1 0 0 0-1.131 0l-2.1 1.439-2.1-1.439a1 1 0 0 0-1.129 0l-1.108 0.752v-16.1a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3z"
}), /*#__PURE__*/React.createElement("rect", {
  transform: "translate(7,8)",
  width: 10,
  height: 2,
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  transform: "translate(7,12)",
  width: 8,
  height: 2,
  rx: 1
}));
function SvgReceipt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceipt);
export default __webpack_public_path__ + "static/media/receipt.1ca30e71.svg";
export { ForwardRef as ReactComponent };